import {  Help  } from "@mui/icons-material";
import {  Tooltip  } from "@mui/material";

const getIconStyles = () => ({
  cursor: 'pointer',
  pointerEvents: 'auto',
  fontSize: '1.5rem',
  margin: '0 0 0 5px',
  color: '#438cc8',
});

interface LabelProperties {
  title: string;
  text: string;
}

class Label extends window.React.PureComponent<LabelProperties> {
  render() {
    const { title, text } = this.props;
    return (
      <div style={{display: 'inline-flex',
				alignItems: 'center',
				marginTop: '-3px'}}>
        {text}
        <Tooltip title={title} placement="right">
          <Help style={getIconStyles()} />
        </Tooltip>
      </div>
    );
  }
}

export default Label;
